const normalizeResearcherNames = researchers =>
  (Array.isArray(researchers) ? researchers : [])
    .map(researcher => (typeof researcher === 'string' ? researcher : researcher?.name || ''))
    .map(name => `${name || ''}`.trim())
    .filter(Boolean);

const normalizeResearcherMembers = client => {
  if (Array.isArray(client?.research_members)) {
    return client.research_members;
  }
  return Array.isArray(client?.researchers)
    ? client.researchers.filter(researcher => researcher && typeof researcher === 'object')
    : [];
};

export const normalizeAgentSkillClient = client => {
  if (!client?.id && !client?.member_id) {
    return null;
  }

  return {
    id: client.id || '',
    member_id: client.member_id || '',
    membership_id: client.membership_id || client.membership?.id || null,
    membership_status: client.membership_status || client.membership?.status || null,
    member: client.member || null,
    tree_id: client.tree_id || '',
    name: client.name || client.client_name || '',
    contacts: client.contacts || [],
    projects_count: Number.isFinite(client.projects_count) ? client.projects_count : 0,
    researchers: normalizeResearcherNames(client.researchers),
    sharepoint_folder: client.sharepoint_folder || '',
    description: client.description || '',
    date_start: client.date_start || null,
    date_end: client.date_end || null,
    created_at: client.created_at || null,
    updated_at: client.updated_at || null,
    hubspot_client_id: client.hubspot_client_id || '',
    research_members: normalizeResearcherMembers(client),
  };
};
